import { render, staticRenderFns } from "./InsightsSection.vue?vue&type=template&id=fe52bd6a&scoped=true&"
import script from "./InsightsSection.vue?vue&type=script&lang=js&"
export * from "./InsightsSection.vue?vue&type=script&lang=js&"
import style0 from "./InsightsSection.vue?vue&type=style&index=0&id=fe52bd6a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe52bd6a",
  null
  
)

export default component.exports